import React from "react";

function TermsContent(props) {
  return (
    <div className="max-width-720 mx-auto">
      <p className="text-uppercase">
        ONLINE SERVICE IS OFFERED BY TANAAD MONEY LTD UK, ORGANIZATION NUMBER
        11100093, LOCATED AT 5 Red Lion Court Alexandra Road, Hounslow-TW3 1JS.
        IF YOU ARE 18 OR OVER AND RESIDENT IN THE EUROPEAN UNION OR EES
        COUNTRIES, YOUR AGREEMENT WITH US WILL BE MADE ON THESE TERMS AND
        CONDITIONS.
      </p>
      <p className="text-uppercase">
        THESE TERMS AND CONDITIONS APPLY TO AND GOVERN YOUR ACCESS TO AND USE OF
        THE TANAAD MONEYONLINE WEB SITE AND THE SERVICES AVAILABLE ON THE TANAAD
        MONEYONLINE WEB SITE.
      </p>
      <p className="text-uppercase fw-bold">
        IT IS IMPORTANT THAT YOU READ AND UNDERSTAND THESE TERMS AND CONDITIONS
        BEFORE YOU ACCEPT THEM. THEY CONTAIN LIMITATIONS ON THE SCOPE OF OUR
        OBLIGATIONS TO YOU, AS WELL AS LIMITATIONS ON AND EXEMPTIONS FROM OUR
        LIABILITY TO YOU IN THE EVENT THAT YOU SUFFER LOSS AS A RESULT OF USING
        OUR SERVICES.
      </p>
      <p>As used in our Terms and Conditions, the terms:</p>
      <ul className="list-alpha">
        <li className="mb-2">
          "Bank Card" refers to a Visa, MasterCard, credit card or debit card
          issued by or through a bank in the European Union member state in
          which the Service is offered;
        </li>
        <li className="mb-2">
          "Card Issuer" refers to the issuer and owner of a Bank Card;
        </li>
        <li className="mb-2">
          "Bank service", "Bank" and/or "Bank account" refers to Bank transfers
          and Mobile transfers through or connected to a bank in the European
          Union and ESS Countries in which the service is offered;
        </li>
        <li className="mb-2">
          "Prohibited Purpose" refers to any unlawful purpose; to making or
          receiving payments for gambling services, gambling chips or gambling
          credits; or to sending a payment to yourself as the Receiver in order
          to evidence financial soundness (RISK OF FRAUD); or sending or
          receiving money on behalf of someone else;
        </li>
        <li className="mb-2">
          "Recipient" refers to the person identified as the beneficiary of a
          money transfer (whether that money transfer is initiated by a Sender
          using the Tanaad Money Online Service or by a person using another
          Tanaad Money transmission service);
        </li>
        <li className="mb-2">
          "Sender" refers to the person who initiates the carrying out of a
          money transfer by using the Tanaad Money Online Service;
        </li>
        <li className="mb-2">
          "Transaction" refers to each money transfer that you initiate under,
          and each other use that you make of, the Tanaad Money Online Service;
        </li>
        <li className="mb-2">
          "Tanaad Money", "we", "our" or "us" refers to Tanaad Money; and, in
          the provisions listed in clause 6.1 and in references to "our
          negligence or fraud", includes any branch, affiliate or agent of
          Tanaad Money when performing a task which would otherwise have to be
          performed by Tanaad Money in connection with its provision of the
          Tanaad Money Online Service;
        </li>
        <li className="mb-2">
          "Tanaad Money Online Service" refers to any or all of the services
          which are made available by us by means of the Tanaad Money Online
          Site;
        </li>
        <li className="mb-2">
          "Tanaad Money Online Site" or "Site" refers to the web site operated
          by us to provide online money transmission services and related
          information facilities; and
        </li>
        <li className="mb-2">
          "you" or "your" refers to any person who uses the Tanaad Money Online
          Site or the Tanaad Money Online Service as a Sender.
        </li>
      </ul>
      <p>
        We may change our Terms and Conditions from time to time. We will notify
        you of any change to our Terms and Conditions by posting a clear and
        readily accessible notice of change on the Tanaad Money Online Site. Our
        Terms and Conditions were last changed in May 2018. No change which we
        may make will affect the terms on which you used the Tanaad Money Online
        Site, or on which we provided the Tanaad Money Online Service to you,
        before we posted the notice of change on the Site. No change which we
        may make will affect your ability to terminate your agreement with us
        under clause 4.1 below
      </p>
      <div>
        <h3 className="text-uppercase fs-3">1. OUR RESPONSIBILITY TO YOU.</h3>
        <p>
          1.1 Our agreement with you is that we will take reasonable care to
          provide the Tanaad Money Online Service. As such, we agree to provide
          you with the money transmission services and the related information
          facilities described from time to time on the Tanaad Money Online
          Site.
        </p>
        <p>
          1.2 We will generally rely without further enquiry on messages that
          are transmitted through the Tanaad Money Online Site and actually
          received by us, unless we have actual notice that any such message is
          incorrect, unauthorised or forged.
        </p>
        <p className="fw-bold">
          1.3 We do not accept any responsibility to you for:
        </p>
        <ul className="list-alpha">
          <li className="mb-2">
            The goods or services which you pay for by using the Tanaad Money
            Online Service;
          </li>
          <li className="mb-2">
            Malfunctions in communications facilities which cannot reasonably be
            considered to be under our control and that may affect the accuracy
            or timeliness of messages you send to us;
          </li>
          <li className="mb-2">
            Any losses or delays in transmission of messages arising out of the
            use of any Internet access service provider or caused by any browser
            or other software which is not under our control;
          </li>
          <li className="mb-2">
            The services provided to you by your card issuer or Bank;
          </li>
          <li className="mb-2">Viruses caused by third parties;</li>
          <li className="mb-2">
            Errors on the Site or with the Tanaad Money Online Service caused by
            incomplete or incorrect information provided to us by you or a third
            party;
          </li>
          <li className="mb-2">
            Any unauthorised use or interception of any message or information
            before it reaches the Site; or
          </li>
          <li className="mb-2">
            Any unauthorised use of or access to data relating to you or your
            Transactions which is held by us (unless such use or access is
            caused by our negligence, fraud or failure to comply with laws
            relating to the protection of your data).
          </li>
        </ul>
      </div>
      <div>
        <p className="fw-bold">
          1.4 We have no obligation to you to initiate or perform a money
          transfer or other Transaction as part of the Tanaad Money Online
          Service if:
        </p>
        <ul className="list-alpha">
          <li className="mb-2">
            We are unable to obtain satisfactory evidence of your identity;
          </li>
          <li className="mb-2">
            We have reason to believe that the Transaction message is incorrect,
            unauthorized or forged;
          </li>
          <li className="mb-2">
            You provide us with incorrect or incomplete information or if your
            Transaction message is not given to us sufficiently in advance to
            allow for timely provision of the requested Transaction; or
          </li>
          <li className="mb-2">
            Your Card Issuer or Bank Service does not authorise your use of your
            Bank Card or Bank Service for payment of the Transaction and our
            related charges,
          </li>
        </ul>
        <p>
          and we do not accept any liability for damages resulting from
          non-payment or delay in payment of a money transfer to a Recipient or
          failure to perform a Transaction under the Tanaad Money Online Service
          by reason of any of these matters.
        </p>
        <p>
          1.5 We may refuse to provide the Tanaad Money Online Service (in whole
          or in part) to you if to do so may breach any Tanaad Money policy
          (including policies intended to prevent fraud, money laundering or
          terrorist financing) and/or any applicable law, order of a court or
          requirement of any regulatory or governmental authority, body or
          agency having jurisdiction over us, or if we otherwise consider such
          action necessary to protect our interests. However, if we refuse to
          provide the Tanaad Money Online Service (in whole or in part) for any
          of these reasons, we will wherever practicable notify you that we have
          done so and, unless we are prevented from doing so for some legal
          reason, we will explain why we have done so.
        </p>
        <p>
          1.6 We may suspend the operation of the Tanaad Money Online Site or
          the Tanaad Money Online Service in whole or in part if, in our
          absolute discretion, we consider it appropriate to do so by reason of
          any circumstances beyond our control. We undertake that if the
          services provided by the Tanaad Money Online Site or the Tanaad Money
          Online Service are interrupted (whether by us, any third party service
          provider or otherwise) for any reason we will take reasonable care to
          minimise the duration of any interruption. Provided we comply with
          this undertaking, we shall not be liable to you for any loss or
          liability which may be suffered or incurred by you as a result of any
          such interruption, even if caused by our negligence, except where any
          such interruption is caused by our fraud.
        </p>
        <p>
          1.7 We will generally communicate with you through the Internet and by
          e-mail. This does not affect your right to communicate with us by any
          other means described in clause
        </p>
        <p>4.1 below in the circumstances contemplated by those provisions.</p>
      </div>
      <div>
        <h3 className="text-uppercase fs-3">2. YOUR RESPONSIBILITY TO US.</h3>
        <p>
          2.1 You agree to pay our charges for each money transfer or other
          Transaction which you initiate or request under the Tanaad Money
          Online Service. Information explaining our charges can be viewed by
          using the "Price It" feature, which provides the estimated cost of
          sending online money transfer (inclusive of tax).
        </p>
        <p>
          2.2 You must pay for the principal amount of a money transfer and our
          charges by using a Bank Card. Each time you use the Tanaad Money
          Online Service, you agree that we are authorised to charge your Card
          Issuer for the principal amount of any money transfer and our charges
          relating to the relevant Transaction before we perform the money
          transfer or other Transaction. The amount that we will charge to your
          Card Issuer will be notified to you prior your final authorisation of
          the Transaction.
        </p>
        <p className="fw-bold">2.3 You acknowledge and agree that:</p>
        <ul className="list-alpha">
          <li className="mb-2">
            When you register with us, you will provide us with true, accurate,
            current and complete information;
          </li>
          <li className="mb-2">
            You will maintain and promptly update such information to keep it
            true, accurate, current and complete;
          </li>
          <li className="mb-2">
            You will not use the Tanaad Money Online Service for or in
            connection with any prohibited purpose;
          </li>
          <li className="mb-2">
            you will not initiate a money transfer or other Transaction under
            the Tanaad Money Online Service in breach of these Terms and
            Conditions or any other restriction or requirement of use described
            on the Tanaad Money Online Site; and
          </li>
          <li className="mb-2">
            You are responsible for the security of your password and e-mail
            account log-in details.
          </li>
        </ul>
      </div>
      <div>
        <p className="fw-bold">
          2.4 You acknowledge and agree that information about you, and the
          services we provide to you, may be provided by us from time to time to
          regulatory or governmental authorities, bodies or agencies where:
        </p>
        <ul className="list-alpha">
          <li className="mb-2">We are required by law to do so; or</li>
          <li className="mb-2">
            If we determine that such disclosure may help to combat fraud, money
            laundering offences, finance of terrorism or other criminal
            activity.
          </li>
        </ul>
        <p className="fw-bold">
          2.5 You agree that you will generally communicate with us through the
          Internet and by e-mail. This does not affect your right to communicate
          with us by any other means described in clause 4.1below in the
          circumstances contemplated by those provisions.
        </p>
      </div>
      <div>
        <h3 className="text-uppercase fs-3">3. FOREIGN EXCHANGE</h3>
        <p>
          3.1 All currency converted under the Tanaad Money Online Service is
          converted at our rate of exchange. Currency is converted at the time
          you initiate a Transaction. The Recipient will receive the foreign
          currency amount notified to you at the time the transfer is initiated,
          except as provided in section 3.3 below.
        </p>
        <p>
          3.2 We use an exchange rate which is comparable to rates used by other
          retail currency exchange facilities which offer exchange of comparable
          amounts of currency to the general public. Our exchange rate may be
          less favourable than some publicly reported commercial exchange rates
          used in Transactions between banks and other financial institutions.
          Any difference between the currency exchange rate offered to you and
          the currency exchange rate received by us will be kept by us, in
          addition to our charges. Additional information about exchange rates
          for specific destination countries can be obtained by using the "Price
          It" feature or by calling the free phone number set out in clause 5
          below.
        </p>
        <p>
          3.3 Money transfers will normally be paid in the currency of the
          destination country. In some countries, payment is available in U.S.
          dollars or other alternate currency. You acknowledge that when you
          initiate a money transfer through the Tanaad Money Online Service, you
          will be required to select the currency in which you wish payment to
          be made to the Recipient. Some Tanaad Money agent locations offer
          Recipients the choice of receiving the funds in a currency that is
          different from the one selected by you. In such cases, we may make
          additional money transfers when your funds are converted into the
          currency selected by the Recipient.
        </p>
      </div>
      <div>
        <h3 className="text-uppercase fs-3">4. CANCELLATION AND REFUNDS.</h3>
        <p>
          4.1 Under laws relating to online contracts, you have a right to
          cancel your agreement with us at any time after you indicate your
          acceptance of our Terms and Conditions. This right of cancellation
          continues until the expiry of 14 days beginning on the day after your
          acceptance of our Terms and Conditions. You may cancel your agreement
          with us by:
        </p>
        <ul className="list-alpha">
          <li className="mb-2">
            Telephoning us on
            <a className="mx-1" href="tel: +442031234567">
              (+44) 203 123 4567
            </a>
            (available daily from 10:00 a.m. to 18:00 p.m.)
          </li>
          <li className="mb-2">
            Writing (mail) to us at:
            <a className="mx-1" href="mailto: info@tanaad.com">
              info@tanaad.com
            </a>
            or by post
            <span className="fw-bold d-block">
              Tanaad Money Ltd, 5 Red Lion Court Alexandra Road, Hounslow-TW3
              1JS
            </span>
          </li>
        </ul>
      </div>
      <div>
        <h3 className="text-uppercase fs-3">5.0 DISPUTE RESOLUTION</h3>
        <p>
          5.1 Alternative dispute resolution. Alternative dispute resolution is
          a process where an independent body considers the facts of a dispute
          and seeks to resolve it, without you having to go to court. If you are
          not happy with how we have handled any complaint, you may want to
          contact the alternative dispute resolution provider made available to
          you. You can submit a complaint to the UK
        </p>
        <p>
          Financial Ombudsman Service (“FOS”). The FOS is a free, independent
          service which might be able to settle a complaint between you and us.
          You may obtain further information regarding the FOS and their contact
          details via www.financial-ombudsman.org.uk. The FOS will not charge
          you for making a complaint and if you are not satisfied with the
          outcome you can still bring legal proceedings.
        </p>
      </div>
      <div>
        <h3 className="text-uppercase fs-3">6.0 Governing Laws</h3>
        <p>
          6.1 <strong> Tanaad Money Ltd </strong>
          (a company duly incorporated and existing under the laws of the
          England & Wales(UK), with registration number 11100093 and registered
          office at 5 Red Lion Court, Alexandra Road, Tw3 1JS-Hounslow
          (hereinafter referred to as the <strong>"Company”</strong>);Registered
          with FCA as PSD agent registration number:842687
        </p>
        <p>
          6.2 Which laws apply to this Agreement and where you may bring legal
          proceedings. The terms of this Agreement are governed by English law.
          This means that this Agreement and any dispute or claim arising out of
          or in connection with it will be governed by English law. You and we
          both agree to that the courts of England and Wales will have
          non-exclusive jurisdiction. However, if you are a resident of Northern
          Ireland you may also bring proceedings in Northern Ireland, and if you
          are a resident of Scotland, you may also bring proceedings in
          Scotland.
        </p>
      </div>
    </div>
  );
}

export default TermsContent;
